"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _DeparturePicker = require("./DeparturePicker.desktop");
var _DeparturePicker2 = require("./DeparturePicker.mobile");
var DeparturePicker = function DeparturePicker(props) {
  var _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_DeparturePicker2.DeparturePickerMobile, props) : /*#__PURE__*/_react["default"].createElement(_DeparturePicker.DeparturePickerDesktop, props);
};
var _default = exports["default"] = DeparturePicker;